import { tokenLogin } from '@/api/usercenter/auth';
import { getUser } from '@/api/usercenter/user';
import { setCurrentStep } from '@/components/guide';
import { setUser } from '@/store/action';
import { initHubspotTracker } from '@/utils/hubspotTracker';
import { getSigData } from '@/utils/nvc';
import { getLoginToken } from '@/utils/session';
import { posthog, postHogInit, zenSigleton } from '@zenlayer/portal-utils';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getRuntimeInfo } from './useRuntimeInfo';

export const posthogConfig: Parameters<typeof postHogInit>[1] = {
  capture_pageview: true,
  capture_pageleave: true,
  enable_heatmaps: true,
  autocapture: { dom_event_allowlist: [] },
};

const checkEventTrackerInit = async (
  userRes: Awaited<ReturnType<typeof getUser>>
) => {
  if (getRuntimeInfo().online !== true) {
    return;
  }
  const isStaff = /@zenlayer\.com$/i.test(userRes.data.username);

  // if is staff in online env, re-init posthog
  if (isStaff) {
    await postHogInit(
      'phc_ID8KCASUeepkZEZkKb2Y8TydvW0WB0e1rl1nWRtX9kH',
      posthogConfig
    );
  }

  posthog.identify(userRes.data.uid, {
    email: userRes.data.username,
    lastname: userRes?.data?.lastName,
    firstname: userRes?.data?.firstName,
    CID: userRes.data.cid,
    TeamName: userRes.data.teamName,
    'Register Date': userRes.data.createTime,
    isStaff,
  });
  initHubspotTracker(userRes.data.uid, userRes.data.username);
};

const handleLoginToken = async (options: {
  onSuccess: () => Promise<void>;
  onFail: () => void;
}) => {
  const { loginToken } = getLoginToken();
  if (loginToken) {
    const { success, msg } = await tokenLogin({
      token: loginToken,
      sig: getSigData(),
    });
    if (success) {
      await options?.onSuccess();
      return;
    } else {
      throw msg;
    }
  } else {
    options?.onFail();
  }
};

export default function useAutoLogin(onFail: () => void) {
  const [logining, setLogining] = useState(true);
  const dispatch = useDispatch();
  const autoLogin = async () => {
    try {
      const userRes = await getUser();
      if (userRes.success) {
        await checkEventTrackerInit(userRes);

        zenSigleton.regist('csrfToken', userRes.data.token, { force: true });
        zenSigleton.regist('teamUid' as any, userRes.data.lastTeamUid, {
          force: true,
        });
        zenSigleton.regist('user' as any, userRes.data, {
          force: true,
        });

        dispatch(setUser(userRes.data));
        //打开新手引导
        if (userRes.data.noviceGuide === 'need') {
          setCurrentStep(1);
        }
      } else {
        await handleLoginToken({
          onSuccess: autoLogin,
          onFail: () => {
            throw userRes.msg;
          },
        });
      }
    } catch (error) {
      onFail();
    }
    setLogining(false);
  };
  useEffect(() => {
    autoLogin();
    return () => {
      zenSigleton.regist('teamUid' as any, undefined, {
        force: true,
      });
      zenSigleton.regist('user' as any, undefined, {
        force: true,
      });
    };
  }, []);
  return { logining };
}
